/* MAX AUTO v1.0.3. Product-detail estimates only. Never edits USD or freight. */
(function () {
  'use strict';
  if (window.MaxLocalCurrency) return;
  const C = window.MaxCurrencyCore;
  const node = document.getElementById('mx-fx-config');
  if (!C || !node) return;
  let cfg;
  try { cfg = JSON.parse(node.textContent); } catch { return; }
  if (cfg.enabled !== true) return;
  const STORE = 'maxauto.fx.preference.v1', CACHE = 'maxauto.fx.rates.v1', RETRY = 'maxauto.fx.retry.v1';
  const owned = '[data-mx-fx-owned]';
  const main = document.getElementById('MainContent') || document.querySelector('main');
  // No card, collection, home or cart enhancement, requests or observers.
  if (!main || !main.querySelector('.hat-vehicle-price')) return;
  const base = { baseCurrency: cfg.baseCurrency, activeCurrency: cfg.activeCurrency, headerCountry: cfg.headerCountry || '' };
  if (base.baseCurrency !== 'USD' || base.activeCurrency !== 'USD') return;
  const storage = {
    get(key) { try { return window.localStorage.getItem(key); } catch { return null; } },
    set(key, value) { try { window.localStorage.setItem(key, JSON.stringify(value)); } catch { /* private mode */ } }
  };
  let state = C.hydrate(storage.get(STORE), base.headerCountry);
  let data, rates = null, rateRequest = null, retryAt = 0, destroyed = false, frame = 0;
  const savedRetry = Number(storage.get(RETRY));
  if (Number.isFinite(savedRetry) && savedRetry > Date.now() && savedRetry <= Date.now() + C.POLICY.fresh) retryAt = savedRetry;
  let reportStatus = 'idle';
  const mounted = new WeakMap(), pickers = new Set(), sources = new Set(), removers = [];
  const locale = cfg.locale || 'en-US';
  const T = (k, f, v) => (window.maxT ? window.maxT(k, f, v) : String(f).replace(/\{(\w+)\}/g, (m, x) => (v && x in v ? v[x] : m)));

  function element(tag, className, text) {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  }
  function text(el, value) { if (el.textContent !== value) el.textContent = value; }
  function listen(el, event, fn) { el.addEventListener(event, fn); removers.push(() => el.removeEventListener(event, fn)); }
  function remember() { storage.set(STORE, state); }
  function selectedCountry() { return main.querySelector('[data-fc-country]')?.value || ''; }
  function isProductPage() { return !!main.querySelector('.hat-vehicle-price'); }
  function active(mode = state.mode) {
    const live = window.Shopify?.currency?.active || base.activeCurrency;
    // Auto follows Shopify's selected store country, never the freight route or
    // a destination remembered by older releases. Manual currency remains valid.
    const choice = C.resolve({ ...state, mode, destination: '' }, { ...base, activeCurrency: live, destination: '' }, data);
    return choice.currency === 'KRW' ? { ...choice, currency: 'USD', source: 'excluded' } : choice;
  }
  function currencyName(code) {
    try { return new Intl.DisplayNames([locale], { type: 'currency' }).of(code) || code; } catch { return code; }
  }

  async function getJSON(url, timeout = 6500) {
    const address = new URL(url, location.href);
    if (address.protocol !== 'https:' && !(address.origin === location.origin && ['localhost','127.0.0.1'].includes(address.hostname))) throw new Error('INSECURE_ENDPOINT');
    const abort = new AbortController();
    const timer = setTimeout(() => abort.abort(), timeout);
    try {
      const response = await fetch(address.href, { signal: abort.signal, credentials: 'omit', mode: 'cors', referrerPolicy: 'no-referrer' });
      if (!response.ok) throw new Error('HTTP_' + response.status);
      return await response.json();
    } finally { clearTimeout(timer); }
  }

  async function refreshRates() {
    if (destroyed || !data || active().currency === 'USD' || active().source === 'blocked') return;
    if (rateRequest || Date.now() < retryAt) return rateRequest;
    if (rates && Date.now() < rates.next && C.freshness(rates) === 'fresh') return;
    rateRequest = (async () => {
      reportStatus = rates ? 'refreshing' : 'loading';
      schedule();
      try {
        const raw = await getJSON(cfg.ratesUrl || 'https://open.er-api.com/v6/latest/USD');
        const validated = C.validateRates(raw);
        if (rates && validated.updated < rates.updated) throw new Error('FX_TIME_REGRESSION');
        if (['expired', 'unavailable'].includes(C.freshness(validated))) throw new Error('FX_TOO_OLD');
        rates = validated;
        storage.set(CACHE, raw);
        // Avoid request storms if the provider has not published its announced next update yet.
        retryAt = Math.max(Date.now() + 30 * 60000, Math.min(rates.next, rates.updated + C.POLICY.fresh));
        reportStatus = 'ready';
      } catch { retryAt = Date.now() + 30 * 60000; reportStatus = 'unavailable'; }
      finally { storage.set(RETRY, retryAt); rateRequest = null; schedule(); }
    })();
    return rateRequest;
  }

  function makePicker() {
    const box = element('div', 'mx-fx-picker');
    box.dataset.mxFxOwned = 'picker';
    const label = element('label', 'mx-fx-picker-label', T('pdp.fx_local_estimate', 'Local estimate'));
    const select = element('select', 'mx-fx-select');
    select.setAttribute('aria-label', T('pdp.fx_select_aria', 'Currency for estimates. Payments remain in USD.'));
    label.append(select); box.append(label);
    select.append(new Option('AUTO · USD', 'AUTO'));
    const codes = [...new Set(['USD', ...Object.values(data.countries)])].filter(code => code !== 'KRW').sort();
    const priority = ['GHS','NGN','EUR','GBP','AED','ZAR','TZS','KES','ZMW','USD'];
    const popular = element('optgroup'); popular.label = T('pdp.fx_frequent', 'Frequently used');
    for (const code of priority) popular.append(new Option(`${code} · ${currencyName(code)}`, code));
    select.append(popular);
    const others = element('optgroup'); others.label = T('pdp.fx_other', 'Other currencies');
    for (const code of codes.filter(c => !priority.includes(c))) others.append(new Option(`${code} · ${currencyName(code)}`, code));
    select.append(others);
    const caption = element('span', 'mx-fx-picker-caption');
    box.append(caption);
    listen(select, 'change', () => {
      state = C.select(state, select.value); remember(); paint(); refreshRates();
      window.dispatchEvent(new CustomEvent('maxauto:currency-change', { detail: { ...active(), mode: state.mode } }));
    });
    pickers.add({ box, select, caption });
    return box;
  }

  function slot(source, kind, parent, after) {
    if (mounted.has(source)) return mounted.get(source);
    const box = element('div', 'mx-fx-estimate mx-fx-estimate--' + kind);
    box.dataset.mxFxOwned = 'amount';
    const value = element('span', 'mx-fx-estimate-value');
    box.append(value);
    if (kind === 'total') {
      const detail = element('span', 'mx-fx-estimate-caption', T('pdp.fx_approx_value', 'Approximate local value'));
      box.append(detail);
    }
    if (after) source.after(box); else parent.append(box);
    const item = { source, kind, box, value };
    mounted.set(source, item); sources.add(item);
    return item;
  }

  function makeDisclosure() {
    const details = element('details', 'mx-fx-about'); details.dataset.mxFxOwned = 'about';
    details.append(element('summary', '', T('pdp.fx_about', 'About currency estimates')));
    const body = element('div', 'mx-fx-about-body');
    const description = element('p', '', T('pdp.fx_about_body', 'Estimates only. All payments and final quotes are in USD. Your bank’s exchange rate and fees may differ.'));
    const rate = element('p', 'mx-fx-rate');
    const attribution = element('a', '', T('pdp.fx_rates_by', 'Rates by ExchangeRate-API'));
    attribution.href = 'https://www.exchangerate-api.com'; attribution.target = '_blank'; attribution.rel = 'noopener noreferrer';
    body.append(description, rate, attribution); details.append(body);
    return details;
  }

  function makeMeta() {
    const meta = element('div', 'mx-fx-meta'); meta.dataset.mxFxOwned = 'meta';
    meta.append(makeDisclosure(), element('p', 'mx-fx-payment-note', T('pdp.fx_payments_usd', 'All payments are in USD.')));
    return meta;
  }

  function mount() {
    const vehicle = main.querySelector('.hat-vehicle-price');
    const total = main.querySelector('.hat-total');
    if (vehicle) {
      slot(vehicle, 'vehicle', vehicle, false);
      if (!main.querySelector('[data-mx-fx-owned="picker"]')) vehicle.before(makePicker());
    }
    if (total) {
      slot(total, 'total', null, true);
      if (!main.querySelector('[data-mx-fx-owned="about"]')) {
        const meta = makeMeta(); mounted.get(total).box.after(meta);
        const status = element('p', 'mx-fx-status'); status.dataset.mxFxOwned = 'status';
        status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); meta.after(status);
      }
    }
  }

  function vehicleMinor() {
    const fc = main.querySelector('[data-fc]');
    const id = main.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value || new URL(location.href).searchParams.get('variant') || fc?.dataset.variantId || cfg.variantId;
    const variant = cfg.variants?.find(v => String(v.id) === String(id));
    // Structured USD Liquid source, independently checked against the currently rendered price.
    if (!variant || !C.validMinor(variant.price)) return null;
    const price = main.querySelector('.hat-vehicle-price .price');
    const el = price?.querySelector(price.classList.contains('price-on-sale') ? '.price-item-sale' : '.price-regular .price-item-regular');
    return el && C.parseUSD(el.textContent) === variant.price ? variant.price : null;
  }

  function quoteValue() {
    const fc = main.querySelector('[data-fc]');
    const href = main.querySelector('[data-request-quotation]')?.href;
    if (!fc || !href) return null;
    const method = fc.querySelector('[data-fc-method]');
    return C.readQuote(href, {
      handle: fc.dataset.handle,
      variantId: main.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value || new URL(location.href).searchParams.get('variant') || fc.dataset.variantId,
      country: fc.querySelector('[data-fc-country]')?.value, port: fc.querySelector('[data-fc-port]')?.value,
      methodReady: !!method && !method.disabled && method.value !== '',
      note: fc.querySelector('[data-fc-note]')?.textContent?.trim(),
      ready: fc.querySelector('[data-fc-note]')?.dataset.fcReady,
      totalText: main.querySelector('.hat-total-value')?.textContent
    });
  }

  function sourceMinor(item) {
    if (item.kind === 'vehicle') return vehicleMinor();
    if (item.kind === 'total') return quoteValue()?.minor ?? null;
    return null;
  }

  function paint() {
    if (destroyed || !data) return;
    mount();
    const choice = active(), code = choice.currency, isLocal = code !== 'USD' && choice.source !== 'blocked';
    const quality = C.freshness(rates);
    for (const picker of pickers) {
      if (!picker.box.isConnected) { pickers.delete(picker); continue; }
      text(picker.select.options[0], 'AUTO · ' + active('auto').currency);
      picker.select.value = state.mode === 'manual' ? state.currency : 'AUTO';
      text(picker.caption, state.mode === 'manual' ? T('pdp.fx_caption_manual', 'Your selected currency · Payment in USD') : T('pdp.fx_caption_auto', 'Store country · Payment in USD'));
    }
    for (const item of sources) {
      if (!item.source.isConnected || !item.box.isConnected) { sources.delete(item); mounted.delete(item.source); continue; }
      const minor = sourceMinor(item);
      const amount = isLocal && minor !== null ? C.convert(minor, code, rates) : null;
      item.box.hidden = amount === null;
      if (amount !== null) {
        text(item.value, '≈ ' + C.format(amount, code, locale));
        item.box.classList.toggle('mx-fx-estimate--stale', quality === 'stale');
        item.box.setAttribute('aria-label', T('pdp.fx_value_aria', 'Approximate value {amount}. Payment in USD.', { amount: C.format(amount, code, locale) }));
      }
    }
    let status = '';
    if (choice.source === 'blocked') status = T('pdp.fx_status_blocked', 'Currency estimates are unavailable for this market.');
    else if (choice.source === 'unknown') status = T('pdp.fx_status_unknown', 'Choose an estimate currency. Store country is unavailable.');
    else if (isLocal && reportStatus === 'loading') status = T('pdp.fx_status_loading', 'Loading local estimate…');
    else if (isLocal && (!rates?.rates[code] || ['expired','unavailable'].includes(quality))) status = T('pdp.fx_status_unavailable', 'Local estimate is temporarily unavailable. USD prices remain valid.');
    for (const el of main.querySelectorAll('[data-mx-fx-owned="status"]')) { text(el, status); el.hidden = !status; }
    for (const el of main.querySelectorAll('.mx-fx-rate')) {
      text(el, isLocal && rates?.rates[code] && ['fresh','stale'].includes(quality)
        ? T('pdp.fx_rate_line', '1 USD ≈ {code} {rate} · Updated {time} UTC. Amounts rounded to whole units.', { code, rate: new Intl.NumberFormat('en-US', {maximumFractionDigits:4}).format(rates.rates[code]), time: new Date(rates.updated).toISOString().slice(0,16).replace('T',' ') })
        : T('pdp.fx_rate_default', 'Reference rates are updated daily. No currency conversion is applied to payments.'));
    }
  }

  function schedule() {
    if (destroyed || frame) return;
    frame = requestAnimationFrame(() => { frame = 0; paint(); });
  }

  function destinationChange() {
    if (!data) return;
    // Painting is deferred until the existing freight event handler has reset its quote.
    schedule(); refreshRates();
  }

  const observer = new MutationObserver(changes => {
    if (changes.some(m => !(m.target.nodeType === 1 ? m.target : m.target.parentElement)?.closest(owned))) schedule();
  });
  async function init() {
    try {
      data = await getJSON(cfg.countriesUrl);
      if (destroyed) return;
      if (!data.countries || !data.aliases) return;
      // Each product-page visit starts on Auto; manual selection still works
      // during this visit. Cards never display local estimates.
      if (isProductPage() || state.currency === 'KRW') state = C.select(state, 'AUTO');
      if (state.currency === 'KRW') state = { ...state, currency: 'USD' };
      state = { ...state, destination: '', destinationAt: 0 };
      const cached = storage.get(CACHE);
      if (cached) { try { rates = C.validateRates(JSON.parse(cached)); } catch { rates = null; } }
      remember();
      observer.observe(main, { childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['href','data-price','data-mx-fx-usd-minor','value'] });
      listen(main, 'change', event => {
        if (event.target.matches('[data-fc-country], [data-fc-port], [data-fc-method]')) destinationChange();
        else if (event.target.matches('[name="id"]')) schedule();
      });
      listen(window, 'storage', event => {
        if (event.key === STORE) {
          state = C.hydrate(event.newValue, base.headerCountry);
          if (state.currency === 'KRW') { state = { ...C.select(state, 'AUTO'), currency: 'USD' }; remember(); }
          schedule(); refreshRates();
        }
        if (event.key === CACHE && event.newValue) {
          try { const next = C.validateRates(JSON.parse(event.newValue)); if (!rates || next.updated >= rates.updated) { rates = next; schedule(); } } catch { /* invalid shared cache */ }
        }
      });
      listen(document, 'visibilitychange', () => { if (!document.hidden) { schedule(); refreshRates(); } });
      listen(window, 'pageshow', event => {
        if (event.persisted && isProductPage()) { state = C.select(state, 'AUTO'); remember(); schedule(); refreshRates(); }
      });
      paint(); await refreshRates();
    } catch { /* An optional enhancement must never prevent the storefront from loading. */ }
  }
  const timer = setInterval(() => { if (!document.hidden) { schedule(); refreshRates(); } }, 5 * 60000);
  window.MaxLocalCurrency = Object.freeze({
    refresh: () => { schedule(); return refreshRates(); },
    state: () => ({ ...state, effective: data ? active() : null, rateStatus: C.freshness(rates) }),
    destroy: () => {
      destroyed = true; observer.disconnect();
      clearInterval(timer); cancelAnimationFrame(frame);
      removers.forEach(fn => fn()); main.querySelectorAll(owned).forEach(el => el.remove());
    }
  });
  init();
})();
